module.exports = __webpack_public_path__ + "img/AT0000039768740.a9524f69.svg";